@use "~dso-toolkit/src/utilities";
@use "~dso-toolkit/src/components/icon";

:host {
  display: inline-block;
  height: icon.$size;
  vertical-align: icon.$vertical-align;
  width: icon.$size;
}

@include utilities.box-sizing();

.icon-container {
  display: block;
  line-height: 0;
}
